module.exports = __webpack_public_path__ + "static/media/2022_2A3A0040.7dcd4aaf.jpg";